import { selectClasses } from '@mui/material'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const C1LabeledSelectStyles: moduleStyleType = {
    selectOverrides: {
        [`& .${selectClasses.select}`]: {
            backgroundColor: 'background.default',
            '&:hover': {
                borderColor: 'primary.main',
            },
        },
    },
}
